export const getIdentityVerificationStatus = (userData) => {
  const explicitStatus = String(userData?.identityVerificationStatus || '').trim().toLowerCase();
  if (explicitStatus === 'retryable_rejected') return 'permanently_rejected';
  if (['permanently_rejected', 'pending', 'verified', 'document_required'].includes(explicitStatus)) {
    return explicitStatus;
  }

  const astraStatus = String(
    userData?.astra?.userStatus || userData?.astraUserStatus || userData?.astra?.status || userData?.astraStatus || ''
  ).trim().toLowerCase();
  const astraUserIntentStatus = String(
    userData?.astra?.userIntentStatus || userData?.astraUserIntentStatus || userData?.astra?.user_intent_status || ''
  ).trim().toLowerCase();
  const astraKycType = String(userData?.astra?.kycType || userData?.astraKycType || '').trim().toLowerCase();
  const combined = `${astraStatus} ${astraUserIntentStatus}`.trim();

  if (astraStatus === 'document' || astraUserIntentStatus === 'document') return 'document_required';
  if (astraStatus.includes('suspend') || astraUserIntentStatus.includes('suspend') || combined.includes('suspend')) {
    return 'permanently_rejected';
  }
  if (astraKycType === 'verified' && ['approved', 'verified', 'active'].includes(astraStatus)) return 'verified';
  if (astraStatus || astraUserIntentStatus || astraKycType) return 'pending';
  return 'not_started';
};

export const isPaymentsUnavailableDueToIdentityRejection = (userData) =>
  getIdentityVerificationStatus(userData) === 'permanently_rejected';

export const isPaymentsUnavailableDueToFailedAch = (userData) =>
  String(userData?.paymentRestrictionStatus || '').trim().toLowerCase() === 'failed_ach_unresolved';

export const isFailedAchRestrictionRetryTarget = (userData, target) => {
  if (!target || !isPaymentsUnavailableDueToFailedAch(userData)) return false;
  const sessionId = String(target?.sessionId || '').trim();
  const inviteId = String(target?.inviteId || '').trim();
  const targetKey = `${sessionId}::${inviteId}`;
  const batchTargets = Array.isArray(userData?.paymentRestrictionTargets) ? userData.paymentRestrictionTargets : [];
  if (batchTargets.some((value) => String(value || '').trim() === targetKey)) return true;
  return String(userData?.paymentRestrictionSessionId || '').trim() === sessionId
    && String(userData?.paymentRestrictionInviteId || '').trim() === inviteId;
};

export const getPaymentCapabilityStatus = (userData, target) => {
  const identityStatus = getIdentityVerificationStatus(userData);
  if (identityStatus === 'permanently_rejected' || identityStatus === 'document_required') return identityStatus;
  if (isPaymentsUnavailableDueToFailedAch(userData) && !isFailedAchRestrictionRetryTarget(userData, target)) {
    return 'failed_ach_unresolved';
  }
  return identityStatus;
};

export const requiresIdentityDocumentVerification = (userData) =>
  getIdentityVerificationStatus(userData) === 'document_required';

export const isIdentityActionRequiredForPayments = (userData, target) =>
  getPaymentCapabilityStatus(userData, target) !== 'verified';

export const isIdentityReviewOrRestrictionBlockingPayments = (userData, target) => {
  const status = getPaymentCapabilityStatus(userData, target);
  return status !== 'verified' && status !== 'not_started';
};

export const getIdentityVerificationWaitOutcome = (status) => {
  if (status === 'verified') return 'verified';
  if (status === 'document_required') return 'document_required';
  if (status === 'permanently_rejected') return 'permanently_rejected';
  return 'pending';
};
